// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { BASE_URL } from "../../config/axios";
// import Logo from "../../assets/images/logo.png";
// import { useNavigate, Link } from "react-router-dom";
// import usePermission from "../../config/permissions";
// import { ToastContainer, toast } from "react-toastify";
// import {
//   Eye,
//   EyeOff,
//   Lock,
//   Mail,
//   ArrowRight,
//   Shield,
//   CheckCircle,
//   AlertTriangle,
//   UserCog,
//   HardHat,
//   ClipboardCheck,
//   LayoutDashboard,
// } from "lucide-react";

// const Login = () => {
//   const navigate = useNavigate();
//   const { updatePermissions } = usePermission();

//   const [errMsg, setErrMsg] = useState("");
//   const [isLoading, setIsLoading] = useState(false);
//   const [formData, setFormData] = useState({ email: "", password: "" });
//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});
//   const [showPassword, setShowPassword] = useState(false);
//   const [capsOn, setCapsOn] = useState(false);
//   const [remember, setRemember] = useState(false);

//   const hour = new Date().getHours();
//   const greeting = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";

//   useEffect(() => {
//     // Browser autofill + remembered email
//     const emailInput = document.getElementById("email");
//     const passwordInput = document.getElementById("password");
//     let savedEmail = "";
//     try { savedEmail = localStorage.getItem("pms_remember_email") || ""; } catch (e) { }
//     const email = (emailInput && emailInput.value) || savedEmail;
//     const password = (passwordInput && passwordInput.value) || "";
//     setFormData({ email, password });
//     setInputState({ email: email ? "green" : "", password: password ? "green" : "" });
//     if (savedEmail) setRemember(true);
//   }, []);

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.email.trim()) {
//       newErrors.email = "Email is required";
//     } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
//       newErrors.email = "Invalid email format";
//     }
//     if (!formData.password) {
//       newErrors.password = "Password is required !";
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (validateForm()) {
//       setIsLoading(true);
//       setErrMsg("");
//       const logingToastId = toast.loading("Authenticating...", {
//         position: "top-center",
//         theme: "colored",
//       });
//       try {
//         let res = await axios.post(`${BASE_URL}/user/login/`, formData);

//         if (res.status === 200) {
//           toast.dismiss(logingToastId);
//           toast.success("Welcome back! Redirecting...", {
//             position: "top-center",
//             autoClose: 1500,
//             theme: "colored",
//           });

//           setTimeout(() => {
//             window.location.reload();
//           }, 1500);

//           const {
//             access, refresh, payload, employeecode, payload_a, letter,
//             sitemanagement_sub_company, sitemanagement_role, sitemanagement_project,
//             sitemanagement_emp_id, sitemanagement_emp_code,
//           } = res.data;

//           const sessionData = {
//             access_token: access || "",
//             refresh_token: refresh || "",
//             role: payload?.role || "",
//             email: payload?.email || "",
//             emp_code: employeecode || "",
//             department: payload_a?.department || "",
//             rh: payload_a?.reporting_head || "",
//             profilepic: payload_a?.profilepic || "",
//             letter_type: letter || "",
//             name: payload_a?.name || "",
//             company: payload_a?.division_name || "",
//             company_id: payload_a?.sub_company_id || "",
//             sitemanagement_role: sitemanagement_role || "",
//             sitemanagement_emp_id: sitemanagement_emp_id || "",
//             sitemanagement_emp_code: sitemanagement_emp_code || "",
//             sitemanagement_project: sitemanagement_project?.id || "",
//             sitemanagement_project_short_name: sitemanagement_project?.project_short_name || "",
//             sitemanagement_project_site_prcode: sitemanagement_project?.site_prcode || "",
//             sitemanagement_project_sub_company: sitemanagement_sub_company || "",
//           };

//           try {
//             if (remember) localStorage.setItem("pms_remember_email", formData.email);
//             else localStorage.removeItem("pms_remember_email");
//           } catch (e) { }

//           Object.entries(sessionData).forEach(([key, value]) => {
//             sessionStorage.setItem(key, value);
//           });

//           updatePermissions(); // Update permissions after setting session storage

//           if (sessionStorage) {
//             navigate("/");
//           }
//         } else {
//           setErrMsg("Invalid Email Or Password");
//         }
//       } catch (err) {
//         console.log(err);
//         setErrMsg(err?.response?.data?.error || "Unable to sign in. Please try again.");

//         toast.dismiss(logingToastId);
//         if (err.response) {
//           const errorData = err.response.data;
//           if (typeof errorData.error === "string") {
//             toast.error(`Error: ${errorData.error}`);
//           } else if (typeof errorData === "object" && errorData !== null) {
//             Object.entries(errorData).forEach(([field, messages]) => {
//               messages.forEach((message) => toast.error(`"${field}": ${message}`));
//             });
//           } else {
//             toast.error("Error:- Failed to Process!");
//           }
//         } else {
//           toast.error("Error processing your request.");
//         }
//       } finally {
//         setIsLoading(false);
//       }
//     } else {
//       console.log("Form contains errors:", errors);
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setInputState({ ...inputState, [name]: value.trim() ? "green" : "" });
//     setFormData({ ...formData, [name]: value });
//     if (errors[name]) setErrors({ ...errors, [name]: "" });
//     if (errMsg) setErrMsg("");
//   };

//   const handleBlur = (e) => {
//     const { name, value } = e.target;
//     if (name === "email" && value.trim() && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
//       setErrors((prev) => ({ ...prev, email: "Invalid email format" }));
//     }
//   };

//   const handleCaps = (e) => {
//     setCapsOn(e.getModifierState ? e.getModifierState("CapsLock") : false);
//   };

//   const forgotpass = () => {
//     navigate("/forgotpassword");
//   };

//   const handleKeyPress = (event) => {
//     if (event.key === "Enter") {
//       event.preventDefault();
//       handleSubmit(event);
//     }
//   };

//   // Signature element: sample supervision schedule (Gantt style, visual only)
//   const weeks = [1, 2, 3, 4, 5, 6, 7, 8];
//   const tasks = [
//     { label: "Site Inspection", x: 140, w: 150, status: "done", pct: "100%" },
//     { label: "Progress Review", x: 240, w: 150, status: "done", pct: "100%" },
//     { label: "Approval", x: 340, w: 125, status: "active", pct: "60%" },
//     { label: "Handover", x: 440, w: 100, status: "planned", pct: "0%" },
//   ];
//   const rowY = (i) => 44 + i * 36;
//   const diamond = (cx, cy) => `${cx},${cy - 6} ${cx + 6},${cy} ${cx},${cy + 6} ${cx - 6},${cy}`;

//   const features = [
//     { icon: <HardHat size={20} />, title: "Site Supervision", text: "Log supervisor visits and daily site work against each project" },
//     { icon: <ClipboardCheck size={20} />, title: "Tasks and Approvals", text: "See what is pending, who owns it, and what is signed off" },
//     { icon: <UserCog size={20} />, title: "Role-Based Access", text: "Separate views for supervisors, engineers and project heads" },
//   ];

//   return (
//     <>
//       <ToastContainer
//         position="top-center"
//         autoClose={3000}
//         hideProgressBar={false}
//         newestOnTop={true}
//         closeOnClick
//         rtl={false}
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="colored"
//       />

//       <div className="pms-login">
//         {/* Left Section - Branding */}
//         <div className="pms-left">
//           <div className="pms-left-content">
//             <div className="pms-logo-container">
//               <Link to="/">
//                 <img src={Logo} alt="Company Logo" className="pms-logo" />
//               </Link>


//               <div className="pms-brand-row">
//                 <div className="pms-brand-icon">
//                   <LayoutDashboard size={28} />
//                 </div>
//                 <h1>PMS <span className="pms-eyebrow"></span></h1>
//               </div>
//               <p className="pms-brand-full">Project Management System (Supervision Projects)</p>

//               {/* <p className="pms-tagline">
//                 Plan, supervise and approve project work from one place, from the first site visit to final handover.
//               </p> */}
//             </div>

//             {/* Signature element */}
//             <div className="pms-schedule" aria-hidden="true">
//               <div className="pms-schedule-head">
//                 <span>Supervision schedule</span>
//                 <span className="pms-tag">Sample view</span>
//               </div>
//               <svg viewBox="0 0 560 190" role="img">
//                 {weeks.map((w, i) => (
//                   <g key={w}>
//                     <line className="pms-grid" x1={140 + i * 50} y1="26" x2={140 + i * 50} y2="184" />
//                     <text className="pms-week" x={165 + i * 50} y="18" textAnchor="middle">W{w}</text>
//                   </g>
//                 ))}
//                 <line className="pms-today" x1="380" y1="26" x2="380" y2="184" />
//                 <text className="pms-today-label" x="380" y="200" textAnchor="middle">Today</text>
//                 <circle className="pms-pulse" cx="380" cy="26" r="4" />
//                 <circle cx="380" cy="26" r="4" fill="#fff" />

//                 {tasks.map((t, i) => (
//                   <g key={t.label} className="pms-task-group">
//                     <text className="pms-row-label" x="0" y={rowY(i) + 11}>{t.label}</text>
//                     <rect
//                       className={`pms-task pms-task-${t.status}`}
//                       style={{ animationDelay: `${0.3 + i * 0.25}s` }}
//                       x={t.x}
//                       y={rowY(i)}
//                       width={t.w}
//                       height="14"
//                       rx="3"
//                     />
//                     <text className={`pms-pct pms-pct-${t.status}`} x={t.x + 8} y={rowY(i) + 10.5}>{t.pct}</text>
//                     <polygon
//                       className={`pms-milestone pms-milestone-${t.status}`}
//                       points={diamond(t.x + t.w, rowY(i) + 7)}
//                     />
//                   </g>
//                 ))}
//               </svg>
//               <div className="pms-legend">
//                 <span><i className="pms-dot pms-dot-done" />Done</span>
//                 <span><i className="pms-dot pms-dot-active" />In progress</span>
//                 <span><i className="pms-dot pms-dot-planned" />Planned</span>
//               </div>
//             </div>

//             <div className="pms-feature-list">
//               {features.map((f) => (
//                 <div className="pms-feature-row" key={f.title}>
//                   <div className="pms-feature-icon">{f.icon}</div>
//                   <div>
//                     <h4>{f.title}</h4>
//                     <p>{f.text}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>

//         {/* Right Section - Login Form */}
//         <div className="pms-right">
//           <div className="pms-form-wrapper">
//             <div className="pms-form-card">
//               <div className="pms-form-header">
//                 <div className="pms-form-header-top">
//                   <div className="pms-header-icon">
//                     <Shield size={22} />
//                   </div>
//                   <h2>{greeting}</h2>
//                 </div>
//                 <p className="pms-header-subtitle">Sign in to manage your supervision projects</p>
//               </div>

//               <form onSubmit={handleSubmit} onKeyDown={handleKeyPress} className="pms-form" noValidate>
//                 <div className="pms-form-group">
//                   <label htmlFor="email" className="pms-form-label">
//                     <Mail size={16} />
//                     <span>Email Address</span>
//                   </label>
//                   <div className={`pms-input-container ${errors.email ? "pms-input-error" : inputState.email ? "pms-input-valid" : ""}`}>
//                     <input
//                       type="text"
//                       id="email"
//                       name="email"
//                       placeholder="Enter your work email"
//                       autoComplete="email"
//                       autoFocus
//                       aria-invalid={!!errors.email}
//                       onBlur={handleBlur}
//                       onChange={handleInputChange}
//                       value={formData.email}
//                       className="pms-form-input"
//                       disabled={isLoading}
//                     />
//                     {inputState.email === "green" && !errors.email && (
//                       <CheckCircle size={18} className="pms-input-icon-valid" />
//                     )}
//                   </div>
//                   {errors.email && <span className="pms-error-message">{errors.email}</span>}
//                 </div>

//                 <div className="pms-form-group">
//                   <label htmlFor="password" className="pms-form-label">
//                     <Lock size={16} />
//                     <span>Password</span>
//                   </label>
//                   <div className={`pms-input-container ${errors.password ? "pms-input-error" : inputState.password ? "pms-input-valid" : ""}`}>
//                     <input
//                       type={showPassword ? "text" : "password"}
//                       placeholder="Enter your password"
//                       id="password"
//                       name="password"
//                       autoComplete="current-password"
//                       aria-invalid={!!errors.password}
//                       onKeyUp={handleCaps}
//                       onBlur={() => setCapsOn(false)}
//                       onChange={handleInputChange}
//                       value={formData.password}
//                       className="pms-form-input"
//                       disabled={isLoading}
//                     />
//                     <button
//                       type="button"
//                       className="pms-password-toggle"
//                       onClick={() => setShowPassword(!showPassword)}
//                       disabled={isLoading}
//                       aria-label={showPassword ? "Hide password" : "Show password"}
//                     >
//                       {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//                     </button>
//                   </div>
//                   {errors.password && <span className="pms-error-message">{errors.password}</span>}
//                   {capsOn && (
//                     <span className="pms-caps">
//                       <AlertTriangle size={14} /> Caps Lock is on
//                     </span>
//                   )}
//                 </div>

//                 <div className="pms-form-options">
//                   <label className="pms-remember">
//                     <input
//                       type="checkbox"
//                       checked={remember}
//                       onChange={(e) => setRemember(e.target.checked)}
//                       disabled={isLoading}
//                     />
//                     <span>Remember my email</span>
//                   </label>
//                   <button type="button" className="pms-forgot" onClick={forgotpass} disabled={isLoading}>
//                     Forgot Password?
//                   </button>
//                 </div>

//                 <button type="submit" className="pms-login-button" disabled={isLoading}>
//                   {isLoading && <span className="pms-spinner" aria-hidden="true" />}
//                   <span>{isLoading ? "Signing in..." : "Sign In"}</span>
//                   {!isLoading && <ArrowRight size={18} />}
//                 </button>

//                 {errMsg && (
//                   <div className="pms-error-alert" role="alert">
//                     <Shield size={16} />
//                     <span>{errMsg}</span>
//                   </div>
//                 )}
//               </form>

//               <p className="pms-form-footer">Need access? Contact your project administrator.</p>
//             </div>
//           </div>
//         </div>
//       </div>

//       <style jsx>{`
//         @import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&display=swap");

//         .pms-login {
//           --ink: #0f2a43;
//           --ink-2: #16385a;
//           --blue: #0879dd;
//           --amber: #f5a524;
//           --paper: #f6f8fa;
//           --line: #d8e0e8;
//           --text: #1e293b;
//           --muted: #64748b;
//           display: flex;
//           min-height: 100vh;
//           font-family: "IBM Plex Sans", "Segoe UI", system-ui, sans-serif;
//           color: var(--text);
//         }

//         /* ---------- Left ---------- */
//         .pms-left {
//           flex: 1.2;
//           position: relative;
//           display: flex;
//           align-items: center;
//           padding: 20px;
//           color: #fff;
//           background-color: var(--ink);
//           background-image:
//             linear-gradient(rgba(255, 255, 255, 0.04) 1px, transparent 1px),
//             linear-gradient(90deg, rgba(255, 255, 255, 0.04) 1px, transparent 1px);
//           background-size: 40px 40px;
//         }

//         .pms-left::after {
//           content: "";
//           position: absolute;
//           top: 0;
//           right: 0;
//           bottom: 0;
//           width: 6px;
//           background: var(--amber);
//         }

//         .pms-left-content {
//           width: 100%;
//           max-width: 580px;
//           margin: 0 auto;
//           display: flex;
//           flex-direction: column;
//           gap: 15px;
//         }

//         .pms-logo {
//           width: 120px;
//           height: auto;
//           margin-bottom: 22px;
//           display: block;
//           filter: brightness(0) invert(1);
//         }

//         .pms-eyebrow {
//           margin: 0 0 12px;
//           font-size: 14px;
//           font-weight: 500;
//           color: var(--amber);
//         }

//         .pms-brand-row {
//           display: flex;
//           align-items: center;
//           gap: 16px;
//         }

//         .pms-brand-icon {
//           width: 56px;
//           height: 56px;
//           border-radius: 8px;
//           background: var(--amber);
//           color: var(--ink);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .pms-brand-row h1 {
//           margin: 0;
//           font-size: 60px;
//           line-height: 1;
//           font-weight: 700;
//           letter-spacing: -0.03em;
//         }

//         .pms-brand-full {
//           margin: 10px 0 0;
//           font-size: 22px;
//           font-weight: 500;
//         }

//         .pms-tagline {
//           margin: 10px 0 0;
//           max-width: 460px;
//           font-size: 16px;
//           line-height: 1.6;
//           color: rgba(255, 255, 255, 0.75);
//         }

//         /* Signature schedule */
//         .pms-schedule {
//           background: var(--ink-2);
//           border: 1px solid rgba(255, 255, 255, 0.14);
//           border-radius: 8px;
//           padding: 18px 20px 14px;
//         }

//         .pms-schedule-head {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 10px;
//           font-size: 14px;
//           font-weight: 600;
//         }

//         .pms-tag {
//           font-size: 12px;
//           font-weight: 500;
//           color: rgba(255, 255, 255, 0.6);
//           border: 1px solid rgba(255, 255, 255, 0.25);
//           border-radius: 4px;
//           padding: 2px 8px;
//         }

//         .pms-schedule svg {
//           width: 100%;
//           height: auto;
//           display: block;
//           overflow: visible;
//           margin-bottom: 14px;
//         }

//         .pms-grid { stroke: rgba(255, 255, 255, 0.1); stroke-width: 1; }
//         .pms-week { fill: rgba(255, 255, 255, 0.55); font-size: 11px; }
//         .pms-row-label { fill: rgba(255, 255, 255, 0.9); font-size: 12px; }
//         .pms-today { stroke: #fff; stroke-width: 1.5; stroke-dasharray: 4 4; }
//         .pms-today-label { fill: #fff; font-size: 11px; font-weight: 600; }

//         .pms-task {
//           transform-box: fill-box;
//           transform-origin: left center;
//           transform: scaleX(0);
//           animation: pms-draw 0.7s ease-out forwards;
//         }
//         .pms-task-done { fill: var(--amber); }
//         .pms-task-active { fill: var(--blue); }
//         .pms-task-planned { fill: transparent; stroke: rgba(255, 255, 255, 0.5); stroke-width: 1.5; stroke-dasharray: 4 3; }

//         .pms-milestone-done { fill: #fff; }
//         .pms-milestone-active { fill: var(--ink-2); stroke: #fff; stroke-width: 1.5; }
//         .pms-milestone-planned { fill: var(--ink-2); stroke: rgba(255, 255, 255, 0.5); stroke-width: 1.5; }

//         @keyframes pms-draw {
//           to { transform: scaleX(1); }
//         }

//         .pms-legend {
//           display: flex;
//           gap: 18px;
//           font-size: 12px;
//           color: rgba(255, 255, 255, 0.75);
//         }

//         .pms-legend span { display: inline-flex; align-items: center; gap: 6px; }
//         .pms-dot { width: 10px; height: 10px; border-radius: 2px; display: inline-block; }
//         .pms-dot-done { background: var(--amber); }
//         .pms-dot-active { background: var(--blue); }
//         .pms-dot-planned { border: 1.5px dashed rgba(255, 255, 255, 0.6); }

//         /* Features */
//         .pms-feature-list { display: flex; flex-direction: column; gap: 16px; }
//         .pms-feature-row { display: flex; gap: 14px; align-items: flex-start; }

//         .pms-feature-icon {
//           flex-shrink: 0;
//           width: 40px;
//           height: 40px;
//           border-radius: 6px;
//           background: rgba(8, 121, 221, 0.28);
//           color: #7cc0f7;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .pms-feature-row h4 { margin: 0 0 2px; font-size: 16px; font-weight: 600; }
//         .pms-feature-row p { margin: 0; font-size: 14px; line-height: 1.5; color: rgba(255, 255, 255, 0.72); }

//         /* ---------- Right ---------- */
//         .pms-right {
//           flex: 1;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           padding: 40px 32px;
//           background: var(--paper);
//         }

//         .pms-form-wrapper { width: 100%; max-width: 440px; }

//         .pms-form-card {
//           background: #fff;
//           border: 1px solid var(--line);
//           border-radius: 8px;
//           padding: 40px;
//         }

//         .pms-form-header { margin-bottom: 28px; }

//         .pms-form-header-top { display: flex; align-items: center; gap: 12px; margin-bottom: 8px; }

//         .pms-header-icon {
//           width: 42px;
//           height: 42px;
//           border-radius: 8px;
//           background: var(--ink);
//           color: var(--amber);
//           display: flex;
//           align-items: center;
//           justify-content: center;
//         }

//         .pms-form-header h2 { margin: 0; font-size: 28px; font-weight: 700; letter-spacing: -0.01em; color: var(--ink); }
//         .pms-header-subtitle { margin: 0; font-size: 15px; color: var(--muted); }

//         .pms-form { display: flex; flex-direction: column; gap: 20px; }
//         .pms-form-group { display: flex; flex-direction: column; gap: 8px; }

//         .pms-form-label {
//           margin: 0;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//           font-size: 14px;
//           font-weight: 600;
//         }

//         .pms-form-label svg { color: var(--blue); }

//         .pms-input-container {
//           position: relative;
//           display: flex;
//           align-items: center;
//           background: #fff;
//           border: 1.5px solid var(--line);
//           border-radius: 6px;
//           transition: border-color 0.2s, box-shadow 0.2s;
//         }

//         .pms-input-container:focus-within { border-color: var(--blue); box-shadow: 0 0 0 3px rgba(8, 121, 221, 0.15); }
//         .pms-input-container.pms-input-error { border-color: #dc2626; background: #fef2f2; }
//         .pms-input-container.pms-input-valid { border-color: #16a34a; }

//         .pms-form-input {
//           width: 100%;
//           margin: 0;
//           border: none;
//           outline: none;
//           background: transparent;
//           font: inherit;
//           font-size: 15px;
//           color: var(--text);
//           padding: 13px 44px 13px 14px;
//           border-radius: 6px;
//         }

//         .pms-form-input::placeholder { color: #94a3b8; }
//         .pms-form-input:disabled { cursor: not-allowed; opacity: 0.7; }

//         .pms-input-icon-valid { position: absolute; right: 14px; color: #16a34a; }

//         .pms-password-toggle {
//           position: absolute;
//           right: 8px;
//           display: flex;
//           padding: 6px;
//           border: none;
//           border-radius: 4px;
//           background: none;
//           color: var(--muted);
//           cursor: pointer;
//         }

//         .pms-password-toggle:hover:not(:disabled) { color: var(--blue); }

//         .pms-password-toggle:focus-visible,
//         .pms-forgot:focus-visible,
//         .pms-login-button:focus-visible { outline: 3px solid rgba(8, 121, 221, 0.4); outline-offset: 2px; }

//         .pms-error-message { font-size: 13px; color: #dc2626; }

//         .pms-form-options { display: flex; justify-content: space-between; align-items: center; margin-top: -6px; }

//         .pms-forgot {
//           padding: 2px 0;
//           border: none;
//           background: none;
//           font: inherit;
//           font-size: 14px;
//           font-weight: 600;
//           color: var(--blue);
//           cursor: pointer;
//         }

//         .pms-forgot:hover:not(:disabled) { text-decoration: underline; }
//         .pms-forgot:disabled { opacity: 0.6; cursor: not-allowed; }

//         .pms-login-button {
//           width: 90%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 10px;
//           padding: 14px 20px;
//           border: none;
//           border-radius: 6px;
//           background: var(--ink);
//           color: #fff;
//           font: inherit;
//           font-size: 16px;
//           font-weight: 600;
//           cursor: pointer;
//           transition: background 0.2s;
//         }

//         .pms-login-button:hover:not(:disabled) { background: var(--blue); }
//         .pms-login-button:disabled { opacity: 0.7; cursor: not-allowed; }

//         .pms-error-alert {
//           display: flex;
//           align-items: center;
//           gap: 10px;
//           padding: 12px 14px;
//           background: #fef2f2;
//           border: 1px solid #fecaca;
//           border-left: 4px solid #dc2626;
//           border-radius: 6px;
//           color: #991b1b;
//           font-size: 14px;
//         }

//         .pms-error-alert svg { flex-shrink: 0; }

//         .pms-form-footer {
//           margin: 24px 0 0;
//           padding-top: 18px;
//           border-top: 1px solid var(--line);
//           font-size: 13px;
//           color: var(--muted);
//           text-align: center;
//         }

//         .pms-remember { display: flex; align-items: center; gap: 8px; margin: 0; font-size: 14px; color: var(--muted); cursor: pointer; user-select: none; }
//         .pms-remember input { width: 16px; height: 16px; margin: 0; accent-color: var(--blue); cursor: pointer; }

//         .pms-caps { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #b45309; }

//         .pms-spinner {
//           width: 16px;
//           height: 16px;
//           border: 2px solid rgba(255, 255, 255, 0.35);
//           border-top-color: #fff;
//           border-radius: 50%;
//           animation: pms-spin 0.8s linear infinite;
//         }

//         @keyframes pms-spin { to { transform: rotate(360deg); } }

//         .pms-pct { font-size: 10px; font-weight: 600; }
//         .pms-pct-done { fill: var(--ink); }
//         .pms-pct-active { fill: #fff; }
//         .pms-pct-planned { fill: rgba(255, 255, 255, 0.6); }

//         .pms-task-group:hover .pms-row-label { fill: var(--amber); }
//         .pms-task-group:hover .pms-task { filter: brightness(1.15); }

//         .pms-pulse {
//           fill: none;
//           stroke: #fff;
//           stroke-width: 1.5;
//           transform-box: fill-box;
//           transform-origin: center;
//           animation: pms-pulse 2s ease-out infinite;
//         }

//         @keyframes pms-pulse {
//           from { transform: scale(1); opacity: 0.9; }
//           to { transform: scale(3.2); opacity: 0; }
//         }

//         @media (prefers-reduced-motion: reduce) {
//           .pms-pulse { animation: none; opacity: 0; }
//           .pms-spinner { animation-duration: 2s; }
//         }

//         /* ---------- Responsive ---------- */
//         @media (max-width: 1024px) {
//           .pms-login { flex-direction: column; }
//           .pms-left { padding: 40px 24px; }
//           .pms-left::after { top: auto; left: 0; width: auto; height: 6px; }
//           .pms-brand-row h1 { font-size: 48px; }
//         }

//         @media (max-width: 640px) {
//           .pms-schedule, .pms-feature-list { display: none; }
//           .pms-left { padding: 32px 20px; }
//           .pms-right { padding: 24px 16px; }
//           .pms-form-card { padding: 28px 22px; }
//           .pms-brand-full { font-size: 19px; }
//         }

//         @media (prefers-reduced-motion: reduce) {
//           .pms-task { animation: none; transform: scaleX(1); }
//           .pms-input-container, .pms-login-button { transition: none; }
//         }
//       `}</style>
//     </>
//   );
// };

// export default Login;



import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import Logo from "../../assets/images/logo.png";
import { useNavigate, Link } from "react-router-dom";
import usePermission from "../../config/permissions";
import { ToastContainer, toast } from "react-toastify";
import {
  Eye,
  EyeOff,
  Lock,
  Mail,
  ArrowRight,
  Shield,
  CheckCircle,
  AlertTriangle,
  UserCog,
  HardHat,
  ClipboardCheck,
  LayoutDashboard,
} from "lucide-react";

const Login = () => {
  const navigate = useNavigate();
  const { updatePermissions } = usePermission();

  const [errMsg, setErrMsg] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [capsOn, setCapsOn] = useState(false);
  const [remember, setRemember] = useState(false);
  const [celebrate, setCelebrate] = useState(false);
  const [sparks, setSparks] = useState([]);

  const hour = new Date().getHours();
  const greeting = hour < 12 ? "Good morning" : hour < 17 ? "Good afternoon" : "Good evening";

  useEffect(() => {
    // Browser autofill + remembered email
    const emailInput = document.getElementById("email");
    const passwordInput = document.getElementById("password");
    let savedEmail = "";
    try { savedEmail = localStorage.getItem("pms_remember_email") || ""; } catch (e) { }
    const email = (emailInput && emailInput.value) || savedEmail;
    const password = (passwordInput && passwordInput.value) || "";
    setFormData({ email, password });
    setInputState({ email: email ? "green" : "", password: password ? "green" : "" });
    if (savedEmail) setRemember(true);
  }, []);

  // Click sparkles (rendered via React so it works with or without scoped styles)
  useEffect(() => {
    const onClick = (e) => {
      const id = Date.now() + Math.random();
      setSparks((p) => [...p.slice(-6), { id, x: e.clientX, y: e.clientY }]);
      setTimeout(() => setSparks((p) => p.filter((s) => s.id !== id)), 800);
    };
    window.addEventListener("click", onClick);
    return () => window.removeEventListener("click", onClick);
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.password) {
      newErrors.password = "Password is required !";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setIsLoading(true);
      setErrMsg("");
      const logingToastId = toast.loading("Authenticating...", {
        position: "top-center",
        theme: "colored",
      });
      try {
        let res = await axios.post(`${BASE_URL}/user/login/`, formData);

        if (res.status === 200) {
          toast.dismiss(logingToastId);
          setCelebrate(true);
          toast.success("Welcome back! Redirecting...", {
            position: "top-center",
            autoClose: 1500,
            theme: "colored",
          });

          setTimeout(() => {
            window.location.reload();
          }, 1500);

          const {
            access, refresh, payload, employeecode, payload_a, letter,
            sitemanagement_sub_company, sitemanagement_role, sitemanagement_project,
            sitemanagement_emp_id, sitemanagement_emp_code,
          } = res.data;

          const sessionData = {
            access_token: access || "",
            refresh_token: refresh || "",
            role: payload?.role || "",
            email: payload?.email || "",
            emp_code: employeecode || "",
            department: payload_a?.department || "",
            rh: payload_a?.reporting_head || "",
            profilepic: payload_a?.profilepic || "",
            letter_type: letter || "",
            name: payload_a?.name || "",
            company: payload_a?.division_name || "",
            company_id: payload_a?.sub_company_id || "",
            sitemanagement_role: sitemanagement_role || "",
            sitemanagement_emp_id: sitemanagement_emp_id || "",
            sitemanagement_emp_code: sitemanagement_emp_code || "",
            sitemanagement_project: sitemanagement_project?.id || "",
            sitemanagement_project_short_name: sitemanagement_project?.project_short_name || "",
            sitemanagement_project_site_prcode: sitemanagement_project?.site_prcode || "",
            sitemanagement_project_sub_company: sitemanagement_sub_company || "",
          };

          try {
            if (remember) localStorage.setItem("pms_remember_email", formData.email);
            else localStorage.removeItem("pms_remember_email");
          } catch (e) { }

          Object.entries(sessionData).forEach(([key, value]) => {
            sessionStorage.setItem(key, value);
          });

          updatePermissions(); // Update permissions after setting session storage

          if (sessionStorage) {
            navigate("/");
          }
        } else {
          setErrMsg("Invalid Email Or Password");
        }
      } catch (err) {
        console.log(err);
        setErrMsg(err?.response?.data?.error || "Unable to sign in. Please try again.");

        toast.dismiss(logingToastId);
        if (err.response) {
          const errorData = err.response.data;
          if (typeof errorData.error === "string") {
            toast.error(`Error: ${errorData.error}`);
          } else if (typeof errorData === "object" && errorData !== null) {
            Object.entries(errorData).forEach(([field, messages]) => {
              messages.forEach((message) => toast.error(`"${field}": ${message}`));
            });
          } else {
            toast.error("Error:- Failed to Process!");
          }
        } else {
          toast.error("Error processing your request.");
        }
      } finally {
        setIsLoading(false);
      }
    } else {
      console.log("Form contains errors:", errors);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState({ ...inputState, [name]: value.trim() ? "green" : "" });
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: "" });
    if (errMsg) setErrMsg("");
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (name === "email" && value.trim() && !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
      setErrors((prev) => ({ ...prev, email: "Invalid email format" }));
    }
  };

  const handleCaps = (e) => {
    setCapsOn(e.getModifierState ? e.getModifierState("CapsLock") : false);
  };

  const forgotpass = () => {
    navigate("/forgotpassword");
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  // Signature element: sample supervision schedule (Gantt style, visual only)
  const weeks = [1, 2, 3, 4, 5, 6, 7, 8];
  const tasks = [
    { label: "Site Inspection", x: 140, w: 150, status: "done", pct: "100%" },
    { label: "Progress Review", x: 240, w: 150, status: "done", pct: "100%" },
    { label: "Approval", x: 340, w: 125, status: "active", pct: "60%" },
    { label: "Handover", x: 440, w: 100, status: "planned", pct: "0%" },
  ];
  const rowY = (i) => 44 + i * 36;
  const diamond = (cx, cy) => `${cx},${cy - 6} ${cx + 6},${cy} ${cx},${cy + 6} ${cx - 6},${cy}`;

  const features = [
    { icon: <HardHat size={20} />, title: "Site Supervision", text: "Log supervisor visits and daily site work against each project" },
    { icon: <ClipboardCheck size={20} />, title: "Tasks and Approvals", text: "See what is pending, who owns it, and what is signed off" },
    { icon: <UserCog size={20} />, title: "Role-Based Access", text: "Separate views for supervisors, engineers and project heads" },
  ];

  // Diwali: string lights (diya colours)
  const bulbColors = ["#ffc93c", "#ff8c1a", "#ff4d4d", "#ff7ab8", "#ffc93c", "#ff8c1a", "#ff4d4d", "#ff7ab8", "#ffc93c", "#ff8c1a", "#ff4d4d", "#ff7ab8", "#ffc93c", "#ff8c1a"];

  // Diwali countdown (edit date if needed: Lakshmi Puja 2026)
  const DIWALI_DATE = new Date("2026-11-08T00:00:00");
  const today0 = new Date(); today0.setHours(0, 0, 0, 0);
  const daysLeft = Math.round((DIWALI_DATE - today0) / 86400000);
  const countdown = daysLeft > 1 ? `Diwali in ${daysLeft} days` : daysLeft === 1 ? "Diwali is tomorrow" : daysLeft === 0 ? "Happy Diwali today!" : "";

  const stars = Array.from({ length: 28 }, (_, i) => ({
    left: `${(i * 53 + 7) % 96}%`,
    top: `${(i * 31 + 11) % 70}%`,
    size: 1 + (i % 3),
    delay: (i % 7) * 0.5,
  }));

  const confetti = Array.from({ length: 44 }, (_, i) => ({
    left: `${(i * 23) % 100}%`,
    color: ["#ffc93c", "#ff8c1a", "#e8335a", "#fff3c4", "#ff7ab8"][i % 5],
    delay: (i % 11) * 0.06,
    dur: 1.3 + (i % 5) * 0.25,
    rot: (i * 47) % 360,
  }));

  // Diyas light up as the form is filled
  const litCount = (inputState.email === "green" ? 2 : 0) + (inputState.password === "green" ? 3 : 0);

  // Rising embers (deterministic so SSR/re-render stays stable)
  const embers = Array.from({ length: 16 }, (_, i) => ({
    left: `${(i * 37 + 8) % 92}%`,
    size: 3 + (i % 4),
    dur: 7 + (i % 6) * 1.4,
    delay: (i % 8) * 0.9,
  }));

  const Lantern = ({ className = "", color = "#ff8c1a" }) => (
    <svg className={`pms-lantern ${className}`} viewBox="0 0 60 120" aria-hidden="true">
      <line x1="30" y1="0" x2="30" y2="22" stroke="#c8860a" strokeWidth="2" />
      <rect x="22" y="20" width="16" height="8" rx="2" fill="#c8860a" />
      <path d="M14 30 Q30 22 46 30 L52 72 Q30 84 8 72 Z" fill={color} />
      <path d="M30 26 L30 78 M20 28 Q16 54 14 74 M40 28 Q44 54 46 74" stroke="rgba(58,10,28,0.45)" strokeWidth="1.5" fill="none" />
      <ellipse cx="30" cy="52" rx="8" ry="14" fill="#fff3c4" opacity="0.85" />
      <rect x="20" y="78" width="20" height="6" rx="2" fill="#c8860a" />
      <path d="M24 84 L22 112 M30 84 L30 116 M36 84 L38 112" stroke="#ffc93c" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );

  const Rangoli = ({ className = "" }) => (
    <svg className={`pms-rangoli ${className}`} viewBox="0 0 200 200" aria-hidden="true">
      <g fill="none" strokeWidth="2.2" strokeLinecap="round">
        <circle cx="100" cy="100" r="92" stroke="#ff8c1a" strokeDasharray="2 9" />
        <circle cx="100" cy="100" r="70" stroke="#c8860a" />
        {Array.from({ length: 12 }).map((_, i) => (
          <path
            key={i}
            d="M100 30 Q112 52 100 70 Q88 52 100 30Z"
            stroke="#e8590c"
            fill="rgba(255,201,60,0.55)"
            transform={`rotate(${i * 30} 100 100)`}
          />
        ))}
        {Array.from({ length: 8 }).map((_, i) => (
          <path
            key={`b${i}`}
            d="M100 74 Q110 88 100 100 Q90 88 100 74Z"
            stroke="#a31c4a"
            fill="rgba(255,140,26,0.6)"
            transform={`rotate(${i * 45} 100 100)`}
          />
        ))}
        <circle cx="100" cy="100" r="9" stroke="#c8860a" fill="#ffc93c" />
      </g>
    </svg>
  );

  const Diya = ({ className = "", lit = true }) => (
    <svg className={`pms-diya ${lit ? "" : "pms-diya-off"} ${className}`} viewBox="0 0 64 56" aria-hidden="true">
      <path className="pms-flame-outer" d="M32 2C24 12 24 22 32 26C40 22 40 12 32 2Z" />
      <path className="pms-flame-inner" d="M32 12C29 16 29 21 32 23C35 21 35 16 32 12Z" />
      <path className="pms-diya-bowl" d="M4 28H60C58 44 46 52 32 52C18 52 6 44 4 28Z" />
      <path className="pms-diya-rim" d="M4 28H60" />
    </svg>
  );

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div className="pms-login">
        {/* Left Section - Branding */}
        <div className="pms-left">
          {/* String lights */}
          <div className="pms-lights" aria-hidden="true">
            {bulbColors.map((c, i) => (
              <span
                key={i}
                className="pms-bulb"
                style={{ "--bulb": c, animationDelay: `${(i % 5) * 0.35}s` }}
              />
            ))}
          </div>

          {/* Fireworks, lanterns, embers (decorative) */}
          <div className="pms-stars" aria-hidden="true">
            {stars.map((st, i) => (
              <i key={i} style={{ left: st.left, top: st.top, width: st.size, height: st.size, animationDelay: `${st.delay}s` }} />
            ))}
          </div>
          <span className="pms-burst pms-burst-1" aria-hidden="true" />
          <span className="pms-burst pms-burst-2" aria-hidden="true" />
          <Lantern className="pms-lantern-a" color="#ff8c1a" />
          <Lantern className="pms-lantern-b" color="#e8335a" />
          <div className="pms-embers" aria-hidden="true">
            {embers.map((e, i) => (
              <i key={i} style={{ left: e.left, width: e.size, height: e.size, animationDuration: `${e.dur}s`, animationDelay: `${e.delay}s` }} />
            ))}
          </div>

          <div className="pms-left-content">
            <div className="pms-logo-container">
              <Link to="/">
                <img src={Logo} alt="Company Logo" className="pms-logo" />
              </Link>

              <div className="pms-brand-row">
                <div className="pms-brand-icon">
                  <LayoutDashboard size={28} />
                </div>
                <h1>PMS <span className="pms-eyebrow"></span></h1>
                <Diya className="pms-diya-brand" />
              </div>
              <p className="pms-brand-full">Project Management System (Supervision Projects)</p>
              <p className="pms-hindi" lang="hi">शुभ दीपावली</p>
              <p className="pms-wish">✨ Wishing you a Happy &amp; Prosperous Diwali ✨</p>
              {countdown && <span className="pms-countdown">🪔 {countdown}</span>}
            </div>

            {/* Signature element */}
            <div className="pms-schedule" aria-hidden="true">
              <div className="pms-schedule-head">
                <span>Supervision schedule</span>
                <span className="pms-tag">Sample view</span>
              </div>
              <svg viewBox="0 0 560 190" role="img">
                {weeks.map((w, i) => (
                  <g key={w}>
                    <line className="pms-grid" x1={140 + i * 50} y1="26" x2={140 + i * 50} y2="184" />
                    <text className="pms-week" x={165 + i * 50} y="18" textAnchor="middle">W{w}</text>
                  </g>
                ))}
                <line className="pms-today" x1="380" y1="26" x2="380" y2="184" />
                <text className="pms-today-label" x="380" y="200" textAnchor="middle">Today</text>
                <circle className="pms-pulse" cx="380" cy="26" r="4" />
                <circle cx="380" cy="26" r="4" fill="#ffc93c" />

                {tasks.map((t, i) => (
                  <g key={t.label} className="pms-task-group">
                    <text className="pms-row-label" x="0" y={rowY(i) + 11}>{t.label}</text>
                    <rect
                      className={`pms-task pms-task-${t.status}`}
                      style={{ animationDelay: `${0.3 + i * 0.25}s` }}
                      x={t.x}
                      y={rowY(i)}
                      width={t.w}
                      height="14"
                      rx="3"
                    />
                    <text className={`pms-pct pms-pct-${t.status}`} x={t.x + 8} y={rowY(i) + 10.5}>{t.pct}</text>
                    <polygon
                      className={`pms-milestone pms-milestone-${t.status}`}
                      points={diamond(t.x + t.w, rowY(i) + 7)}
                    />
                  </g>
                ))}
              </svg>
              <div className="pms-legend">
                <span><i className="pms-dot pms-dot-done" />Done</span>
                <span><i className="pms-dot pms-dot-active" />In progress</span>
                <span><i className="pms-dot pms-dot-planned" />Planned</span>
              </div>
            </div>

            <div className="pms-feature-list">
              {features.map((f) => (
                <div className="pms-feature-row" key={f.title}>
                  <div className="pms-feature-icon">{f.icon}</div>
                  <div>
                    <h4>{f.title}</h4>
                    <p>{f.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right Section - Login Form */}
        <div className="pms-right">
          <Rangoli className="pms-rangoli-tr" />
          <Rangoli className="pms-rangoli-bl" />
          <div className="pms-form-wrapper">
            <div className="pms-form-card">
              <div className="pms-form-header">
                <div className="pms-form-header-top">
                  <div className="pms-header-icon">
                    <Shield size={22} />
                  </div>
                  <h2>{greeting}</h2>
                  <Diya className="pms-diya-form" />
                </div>
                <p className="pms-header-subtitle">Sign in to manage your supervision projects</p>
              </div>

              <form onSubmit={handleSubmit} onKeyDown={handleKeyPress} className="pms-form" noValidate>
                <div className="pms-form-group">
                  <label htmlFor="email" className="pms-form-label">
                    <Mail size={16} />
                    <span>Email Address</span>
                  </label>
                  <div className={`pms-input-container ${errors.email ? "pms-input-error" : inputState.email ? "pms-input-valid" : ""}`}>
                    <input
                      type="text"
                      id="email"
                      name="email"
                      placeholder="Enter your work email"
                      autoComplete="email"
                      autoFocus
                      aria-invalid={!!errors.email}
                      onBlur={handleBlur}
                      onChange={handleInputChange}
                      value={formData.email}
                      className="pms-form-input"
                      disabled={isLoading}
                    />
                    {inputState.email === "green" && !errors.email && (
                      <CheckCircle size={18} className="pms-input-icon-valid" />
                    )}
                  </div>
                  {errors.email && <span className="pms-error-message">{errors.email}</span>}
                </div>

                <div className="pms-form-group">
                  <label htmlFor="password" className="pms-form-label">
                    <Lock size={16} />
                    <span>Password</span>
                  </label>
                  <div className={`pms-input-container ${errors.password ? "pms-input-error" : inputState.password ? "pms-input-valid" : ""}`}>
                    <input
                      type={showPassword ? "text" : "password"}
                      placeholder="Enter your password"
                      id="password"
                      name="password"
                      autoComplete="current-password"
                      aria-invalid={!!errors.password}
                      onKeyUp={handleCaps}
                      onBlur={() => setCapsOn(false)}
                      onChange={handleInputChange}
                      value={formData.password}
                      className="pms-form-input"
                      disabled={isLoading}
                    />
                    <button
                      type="button"
                      className="pms-password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                      disabled={isLoading}
                      aria-label={showPassword ? "Hide password" : "Show password"}
                    >
                      {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </button>
                  </div>
                  {errors.password && <span className="pms-error-message">{errors.password}</span>}
                  {capsOn && (
                    <span className="pms-caps">
                      <AlertTriangle size={14} /> Caps Lock is on
                    </span>
                  )}
                </div>

                <div className="pms-form-options">
                  <label className="pms-remember">
                    <input
                      type="checkbox"
                      checked={remember}
                      onChange={(e) => setRemember(e.target.checked)}
                      disabled={isLoading}
                    />
                    <span>Remember my email</span>
                  </label>
                  <button type="button" className="pms-forgot" onClick={forgotpass} disabled={isLoading}>
                    Forgot Password?
                  </button>
                </div>

                <button type="submit" className="pms-login-button" disabled={isLoading}>
                  {isLoading && <span className="pms-spinner" aria-hidden="true" />}
                  <span>{isLoading ? "Signing in..." : "Sign In"}</span>
                  {!isLoading && <ArrowRight size={18} />}
                </button>

                {errMsg && (
                  <div className="pms-error-alert" role="alert">
                    <Shield size={16} />
                    <span>{errMsg}</span>
                  </div>
                )}
              </form>

              <p className="pms-form-footer">Need access? Contact your project administrator.</p>
            </div>
            <div className="pms-diya-row" aria-hidden="true">
              {[0, 1, 2, 3, 4].map((i) => (
                <Diya key={i} className="pms-diya-mini" lit={isLoading || i < litCount} />
              ))}
            </div>
          </div>
        </div>
      </div>

      {sparks.map((sp) => (
        <span key={sp.id} className="pms-spark" style={{ left: sp.x, top: sp.y }} aria-hidden="true">
          {[0, 1, 2, 3, 4, 5, 6, 7].map((k) => (
            <i key={k} style={{ "--a": `${k * 45}deg` }} />
          ))}
        </span>
      ))}

      {celebrate && (
        <div className="pms-confetti" aria-hidden="true">
          {confetti.map((c, i) => (
            <i key={i} style={{ left: c.left, background: c.color, animationDelay: `${c.delay}s`, animationDuration: `${c.dur}s`, "--r": `${c.rot}deg` }} />
          ))}
        </div>
      )}

      <style jsx>{`
        @import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;500;600;700&family=Yatra+One&display=swap");

        .pms-login {
          /* Diwali palette */
          --maroon: #3a0a1c;
          --maroon-2: #5a1230;
          --saffron: #ff8c1a;
          --gold: #ffc93c;
          --gold-deep: #c8860a;
          --paper: #fff6e5;
          --line: #f0d9ae;
          --text: #2b1620;
          --muted: #7a5c52;
          display: flex;
          min-height: 100vh;
          font-family: "IBM Plex Sans", "Segoe UI", system-ui, sans-serif;
          color: var(--text);
        }

        /* ---------- Left ---------- */
        .pms-left {
          flex: 1.2;
          position: relative;
          display: flex;
          align-items: center;
          padding: 70px 20px 20px;
          color: #fff;
          overflow: hidden;
          background-color: var(--maroon);
          background-image:
            radial-gradient(circle at 15% 85%, rgba(255, 140, 26, 0.28), transparent 45%),
            radial-gradient(circle at 90% 10%, rgba(255, 201, 60, 0.16), transparent 40%),
            radial-gradient(rgba(255, 201, 60, 0.18) 1.2px, transparent 1.6px);
          background-size: auto, auto, 28px 28px;
        }

        /* Marigold garland edge */
        .pms-left::after {
          content: "";
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          width: 10px;
          background:
            repeating-linear-gradient(
              180deg,
              var(--saffron) 0 12px,
              var(--gold) 12px 24px,
              #e8590c 24px 36px,
              var(--gold) 36px 48px
            );
        }

        /* String lights */
        .pms-lights {
          position: absolute;
          top: 0;
          left: 0;
          right: 10px;
          height: 54px;
          display: flex;
          justify-content: space-around;
          padding: 0 12px;
          pointer-events: none;
        }

        .pms-lights::before {
          content: "";
          position: absolute;
          top: 8px;
          left: 0;
          right: 0;
          height: 2px;
          background: var(--gold-deep);
          opacity: 0.8;
        }

        .pms-bulb {
          position: relative;
          top: 10px;
          width: 12px;
          height: 20px;
          border-radius: 50% 50% 55% 55%;
          background: var(--bulb);
          box-shadow: 0 0 10px 3px var(--bulb);
          animation: pms-twinkle 2.2s ease-in-out infinite;
        }

        .pms-bulb::before {
          content: "";
          position: absolute;
          top: -6px;
          left: 3px;
          width: 6px;
          height: 7px;
          background: var(--gold-deep);
          border-radius: 1px;
        }

        @keyframes pms-twinkle {
          0%, 100% { opacity: 1; box-shadow: 0 0 12px 4px var(--bulb); }
          50% { opacity: 0.45; box-shadow: 0 0 4px 1px var(--bulb); }
        }

        .pms-left-content {
          width: 100%;
          max-width: 580px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          gap: 15px;
          position: relative;
          z-index: 1;
        }

        .pms-logo {
          width: 120px;
          height: auto;
          margin-bottom: 22px;
          display: block;
          filter: brightness(0) invert(1);
        }

        .pms-eyebrow {
          margin: 0 0 12px;
          font-size: 14px;
          font-weight: 500;
          color: var(--gold);
        }

        .pms-brand-row {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .pms-brand-icon {
          width: 56px;
          height: 56px;
          border-radius: 8px;
          background: linear-gradient(135deg, var(--gold), var(--saffron));
          color: var(--maroon);
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 0 22px rgba(255, 201, 60, 0.45);
        }

        .pms-brand-row h1 {
          margin: 0;
          font-size: 60px;
          line-height: 1;
          font-weight: 700;
          letter-spacing: -0.03em;
          background: linear-gradient(180deg, #fff 30%, var(--gold));
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .pms-brand-full {
          margin: 10px 0 0;
          font-size: 22px;
          font-weight: 500;
        }

        .pms-wish {
          margin: 8px 0 0;
          font-size: 15px;
          font-weight: 600;
          color: var(--gold);
          letter-spacing: 0.02em;
        }

        .pms-tagline {
          margin: 10px 0 0;
          max-width: 460px;
          font-size: 16px;
          line-height: 1.6;
          color: rgba(255, 255, 255, 0.75);
        }

        /* Diya */
        .pms-diya { width: 48px; height: auto; flex-shrink: 0; overflow: visible; }
        .pms-diya-brand { margin-left: auto; width: 56px; }
        .pms-diya-form { margin-left: auto; width: 40px; }
        .pms-diya-bowl { fill: var(--saffron); }
        .pms-diya-rim { stroke: var(--gold); stroke-width: 3; stroke-linecap: round; fill: none; }
        .pms-flame-outer {
          fill: var(--gold);
          transform-box: fill-box;
          transform-origin: 50% 100%;
          animation: pms-flicker 1.6s ease-in-out infinite;
          filter: drop-shadow(0 0 6px rgba(255, 201, 60, 0.9));
        }
        .pms-flame-inner {
          fill: #fff3c4;
          transform-box: fill-box;
          transform-origin: 50% 100%;
          animation: pms-flicker 1.2s ease-in-out infinite reverse;
        }

        @keyframes pms-flicker {
          0%, 100% { transform: scale(1, 1) rotate(0deg); }
          30% { transform: scale(0.94, 1.08) rotate(-2deg); }
          60% { transform: scale(1.04, 0.95) rotate(2deg); }
        }

        /* Signature schedule */
        .pms-schedule {
          background: rgba(90, 18, 48, 0.75);
          border: 1px solid rgba(255, 201, 60, 0.35);
          border-radius: 8px;
          padding: 18px 20px 14px;
          box-shadow: 0 0 30px rgba(255, 140, 26, 0.12);
        }

        .pms-schedule-head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: 600;
          color: var(--gold);
        }

        .pms-tag {
          font-size: 12px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.7);
          border: 1px solid rgba(255, 201, 60, 0.4);
          border-radius: 4px;
          padding: 2px 8px;
        }

        .pms-schedule svg {
          width: 100%;
          height: auto;
          display: block;
          overflow: visible;
          margin-bottom: 14px;
        }

        .pms-grid { stroke: rgba(255, 201, 60, 0.14); stroke-width: 1; }
        .pms-week { fill: rgba(255, 233, 180, 0.65); font-size: 11px; }
        .pms-row-label { fill: rgba(255, 255, 255, 0.92); font-size: 12px; }
        .pms-today { stroke: var(--gold); stroke-width: 1.5; stroke-dasharray: 4 4; }
        .pms-today-label { fill: var(--gold); font-size: 11px; font-weight: 600; }

        .pms-task {
          transform-box: fill-box;
          transform-origin: left center;
          transform: scaleX(0);
          animation: pms-draw 0.7s ease-out forwards;
        }
        .pms-task-done { fill: var(--gold); }
        .pms-task-active { fill: var(--saffron); }
        .pms-task-planned { fill: transparent; stroke: rgba(255, 233, 180, 0.6); stroke-width: 1.5; stroke-dasharray: 4 3; }

        .pms-milestone-done { fill: #fff; }
        .pms-milestone-active { fill: var(--maroon-2); stroke: var(--gold); stroke-width: 1.5; }
        .pms-milestone-planned { fill: var(--maroon-2); stroke: rgba(255, 233, 180, 0.6); stroke-width: 1.5; }

        @keyframes pms-draw {
          to { transform: scaleX(1); }
        }

        .pms-legend {
          display: flex;
          gap: 18px;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.78);
        }

        .pms-legend span { display: inline-flex; align-items: center; gap: 6px; }
        .pms-dot { width: 10px; height: 10px; border-radius: 2px; display: inline-block; }
        .pms-dot-done { background: var(--gold); }
        .pms-dot-active { background: var(--saffron); }
        .pms-dot-planned { border: 1.5px dashed rgba(255, 233, 180, 0.7); }

        /* Features */
        .pms-feature-list { display: flex; flex-direction: column; gap: 16px; }
        .pms-feature-row { display: flex; gap: 14px; align-items: flex-start; }

        .pms-feature-icon {
          flex-shrink: 0;
          width: 40px;
          height: 40px;
          border-radius: 6px;
          background: rgba(255, 140, 26, 0.22);
          border: 1px solid rgba(255, 201, 60, 0.35);
          color: var(--gold);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .pms-feature-row h4 { margin: 0 0 2px; font-size: 16px; font-weight: 600; }
        .pms-feature-row p { margin: 0; font-size: 14px; line-height: 1.5; color: rgba(255, 255, 255, 0.75); }

        /* ---------- Right ---------- */
        .pms-right {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 40px 32px;
          background-color: var(--paper);
          background-image:
            radial-gradient(circle at 100% 0%, rgba(255, 140, 26, 0.18), transparent 35%),
            radial-gradient(circle at 0% 100%, rgba(255, 201, 60, 0.25), transparent 40%),
            radial-gradient(rgba(200, 134, 10, 0.12) 1.2px, transparent 1.6px);
          background-size: auto, auto, 24px 24px;
        }

        .pms-form-wrapper { width: 100%; max-width: 440px; }

        .pms-form-card {
          background: #fffdf8;
          border: 1px solid var(--line);
          border-top: 5px solid var(--saffron);
          border-radius: 8px;
          padding: 40px;
          box-shadow: 0 12px 40px rgba(122, 60, 10, 0.12);
        }

        .pms-form-header { margin-bottom: 28px; }

        .pms-form-header-top { display: flex; align-items: center; gap: 12px; margin-bottom: 8px; }

        .pms-header-icon {
          width: 42px;
          height: 42px;
          border-radius: 8px;
          background: var(--maroon);
          color: var(--gold);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .pms-form-header h2 { margin: 0; font-size: 28px; font-weight: 700; letter-spacing: -0.01em; color: var(--maroon); }
        .pms-header-subtitle { margin: 0; font-size: 15px; color: var(--muted); }

        .pms-form { display: flex; flex-direction: column; gap: 20px; }
        .pms-form-group { display: flex; flex-direction: column; gap: 8px; }

        .pms-form-label {
          margin: 0;
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 600;
          color: var(--maroon);
        }

        .pms-form-label svg { color: var(--saffron); }

        .pms-input-container {
          position: relative;
          display: flex;
          align-items: center;
          background: #fff;
          border: 1.5px solid var(--line);
          border-radius: 6px;
          transition: border-color 0.2s, box-shadow 0.2s;
        }

        .pms-input-container:focus-within { border-color: var(--saffron); box-shadow: 0 0 0 3px rgba(255, 140, 26, 0.2); }
        .pms-input-container.pms-input-error { border-color: #dc2626; background: #fef2f2; }
        .pms-input-container.pms-input-valid { border-color: #16a34a; }

        .pms-form-input {
          width: 100%;
          margin: 0;
          border: none;
          outline: none;
          background: transparent;
          font: inherit;
          font-size: 15px;
          color: var(--text);
          padding: 13px 44px 13px 14px;
          border-radius: 6px;
        }

        .pms-form-input::placeholder { color: #b49a8a; }
        .pms-form-input:disabled { cursor: not-allowed; opacity: 0.7; }

        .pms-input-icon-valid { position: absolute; right: 14px; color: #16a34a; }

        .pms-password-toggle {
          position: absolute;
          right: 8px;
          display: flex;
          padding: 6px;
          border: none;
          border-radius: 4px;
          background: none;
          color: var(--muted);
          cursor: pointer;
        }

        .pms-password-toggle:hover:not(:disabled) { color: var(--saffron); }

        .pms-password-toggle:focus-visible,
        .pms-forgot:focus-visible,
        .pms-login-button:focus-visible { outline: 3px solid rgba(255, 140, 26, 0.5); outline-offset: 2px; }

        .pms-error-message { font-size: 13px; color: #dc2626; }

        .pms-form-options { display: flex; justify-content: space-between; align-items: center; margin-top: -6px; }

        .pms-forgot {
          padding: 2px 0;
          border: none;
          background: none;
          font: inherit;
          font-size: 14px;
          font-weight: 600;
          color: #d9560b;
          cursor: pointer;
        }

        .pms-forgot:hover:not(:disabled) { text-decoration: underline; }
        .pms-forgot:disabled { opacity: 0.6; cursor: not-allowed; }

        .pms-login-button {
          width: 90%;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          padding: 14px 20px;
          border: none;
          border-radius: 6px;
          background: linear-gradient(135deg, var(--maroon-2), var(--maroon));
          color: var(--gold);
          font: inherit;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          box-shadow: 0 4px 14px rgba(58, 10, 28, 0.3);
          transition: background 0.2s, color 0.2s, box-shadow 0.2s;
        }

        .pms-login-button:hover:not(:disabled) {
          background: linear-gradient(135deg, var(--gold), var(--saffron));
          color: var(--maroon);
          box-shadow: 0 4px 18px rgba(255, 140, 26, 0.5);
        }
        .pms-login-button:disabled { opacity: 0.7; cursor: not-allowed; }

        .pms-error-alert {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px 14px;
          background: #fef2f2;
          border: 1px solid #fecaca;
          border-left: 4px solid #dc2626;
          border-radius: 6px;
          color: #991b1b;
          font-size: 14px;
        }

        .pms-error-alert svg { flex-shrink: 0; }

        .pms-form-footer {
          margin: 24px 0 0;
          padding-top: 18px;
          border-top: 1px dashed var(--line);
          font-size: 13px;
          color: var(--muted);
          text-align: center;
        }

        .pms-remember { display: flex; align-items: center; gap: 8px; margin: 0; font-size: 14px; color: var(--muted); cursor: pointer; user-select: none; }
        .pms-remember input { width: 16px; height: 16px; margin: 0; accent-color: var(--saffron); cursor: pointer; }

        .pms-caps { display: flex; align-items: center; gap: 6px; font-size: 13px; color: #b45309; }

        .pms-spinner {
          width: 16px;
          height: 16px;
          border: 2px solid rgba(255, 201, 60, 0.35);
          border-top-color: var(--gold);
          border-radius: 50%;
          animation: pms-spin 0.8s linear infinite;
        }

        @keyframes pms-spin { to { transform: rotate(360deg); } }

        .pms-pct { font-size: 10px; font-weight: 600; }
        .pms-pct-done { fill: var(--maroon); }
        .pms-pct-active { fill: var(--maroon); }
        .pms-pct-planned { fill: rgba(255, 233, 180, 0.75); }

        .pms-task-group:hover .pms-row-label { fill: var(--gold); }
        .pms-task-group:hover .pms-task { filter: brightness(1.15); }

        .pms-pulse {
          fill: none;
          stroke: var(--gold);
          stroke-width: 1.5;
          transform-box: fill-box;
          transform-origin: center;
          animation: pms-pulse 2s ease-out infinite;
        }

        @keyframes pms-pulse {
          from { transform: scale(1); opacity: 0.9; }
          to { transform: scale(3.2); opacity: 0; }
        }

        @media (prefers-reduced-motion: reduce) {
          .pms-pulse { animation: none; opacity: 0; }
          .pms-spinner { animation-duration: 2s; }
          .pms-bulb, .pms-flame-outer, .pms-flame-inner { animation: none; }
        }


        /* ===== Diwali enhancements ===== */
        .pms-embers { position: absolute; inset: 0; pointer-events: none; overflow: hidden; }
        .pms-embers i {
          position: absolute;
          bottom: -10px;
          border-radius: 50%;
          background: radial-gradient(circle, #fff3c4, var(--saffron));
          box-shadow: 0 0 8px 2px rgba(255, 140, 26, 0.8);
          opacity: 0;
          animation-name: pms-rise;
          animation-timing-function: ease-in;
          animation-iteration-count: infinite;
        }
        @keyframes pms-rise {
          0% { transform: translate(0, 0) scale(1); opacity: 0; }
          10% { opacity: 0.95; }
          100% { transform: translate(24px, -105vh) scale(0.3); opacity: 0; }
        }

        .pms-burst {
          position: absolute;
          width: 130px;
          height: 130px;
          border-radius: 50%;
          pointer-events: none;
          background: repeating-conic-gradient(var(--gold) 0 3deg, transparent 3deg 22.5deg);
          -webkit-mask: radial-gradient(circle, transparent 16%, #000 18%, #000 58%, transparent 62%);
          mask: radial-gradient(circle, transparent 16%, #000 18%, #000 58%, transparent 62%);
          opacity: 0;
          animation: pms-burst 5s ease-out infinite;
        }
        .pms-burst-1 { top: 90px; left: 6%; }
        .pms-burst-2 { top: 40%; right: 5%; width: 100px; height: 100px; animation-delay: 2.4s;
          background: repeating-conic-gradient(var(--saffron) 0 3deg, transparent 3deg 30deg); }
        @keyframes pms-burst {
          0% { transform: scale(0.1); opacity: 0; }
          12% { opacity: 1; }
          60% { transform: scale(1.1); opacity: 0.55; }
          100% { transform: scale(1.35); opacity: 0; }
        }

        .pms-lantern { position: absolute; top: 40px; width: 44px; height: auto; pointer-events: none; transform-origin: 50% 0; animation: pms-sway 4.5s ease-in-out infinite; filter: drop-shadow(0 0 14px rgba(255, 170, 40, 0.65)); z-index: 1; }
        .pms-lantern-a { right: 9%; }
        .pms-lantern-b { right: 19%; width: 34px; top: 38px; animation-delay: 1.2s; }
        @keyframes pms-sway { 0%, 100% { transform: rotate(-5deg); } 50% { transform: rotate(5deg); } }

        .pms-wish {
          background: linear-gradient(90deg, var(--gold) 20%, #fff 45%, var(--gold) 70%);
          background-size: 220% 100%;
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          animation: pms-shimmer 4s linear infinite;
        }
        @keyframes pms-shimmer { from { background-position: 120% 0; } to { background-position: -100% 0; } }

        /* Right: rangoli + toran + diya row */
        .pms-right { position: relative; overflow: hidden; flex-direction: column; }
        .pms-rangoli { position: absolute; width: 300px; height: 300px; opacity: 0.38; pointer-events: none; animation: pms-spin-slow 90s linear infinite; }
        .pms-rangoli-tr { top: -90px; right: -90px; }
        .pms-rangoli-bl { bottom: -110px; left: -110px; width: 340px; height: 340px; animation-direction: reverse; }
        @keyframes pms-spin-slow { to { transform: rotate(360deg); } }

        .pms-form-wrapper { position: relative; z-index: 1; }

        .pms-form-card { position: relative; border-top: none; padding-top: 52px; animation: pms-card-in 0.7s ease-out both; }
        .pms-form-card::before {
          content: "";
          position: absolute;
          top: 0; left: 0; right: 0;
          height: 22px;
          border-radius: 8px 8px 0 0;
          background:
            radial-gradient(circle at 11px 8px, var(--gold) 5px, transparent 5.5px) 0 0 / 22px 22px repeat-x,
            radial-gradient(circle at 11px 8px, var(--saffron) 5px, transparent 5.5px) 11px 6px / 44px 22px repeat-x,
            linear-gradient(var(--saffron), var(--saffron)) 0 0 / 100% 4px no-repeat;
        }
        @keyframes pms-card-in { from { opacity: 0; transform: translateY(18px); } to { opacity: 1; transform: none; } }

        .pms-diya-row { display: flex; justify-content: center; gap: 22px; margin-top: 22px; }
        .pms-diya-mini { width: 30px; }
        .pms-diya-mini:nth-child(2n) .pms-flame-outer { animation-delay: 0.5s; }
        .pms-diya-mini:nth-child(3n) .pms-flame-outer { animation-delay: 1s; }

        .pms-login-button { position: relative; overflow: hidden; }
        .pms-login-button::after {
          content: "";
          position: absolute;
          top: 0; bottom: 0; left: -60%;
          width: 40%;
          background: linear-gradient(100deg, transparent, rgba(255, 255, 255, 0.45), transparent);
          transform: skewX(-20deg);
        }
        .pms-login-button:hover:not(:disabled)::after { left: 130%; transition: left 0.7s ease; }

        .pms-form-input:focus ~ .pms-input-icon-valid { filter: drop-shadow(0 0 4px rgba(22, 163, 74, 0.5)); }

        @media (max-width: 1024px) {
          .pms-lantern-a { right: 6%; }
          .pms-lantern-b { right: 16%; }
          .pms-rangoli { width: 220px; height: 220px; }
        }
        @media (max-width: 640px) {
          .pms-burst, .pms-lantern-b { display: none; }
          .pms-lantern-a { width: 34px; }
          .pms-diya-row { gap: 14px; }
        }
        @media (prefers-reduced-motion: reduce) {
          .pms-embers, .pms-burst { display: none; }
          .pms-lantern, .pms-rangoli, .pms-wish, .pms-form-card { animation: none; }
        }


        /* ===== Diwali enhancements v3 ===== */
        .pms-stars { position: absolute; inset: 0; pointer-events: none; }
        .pms-stars i {
          position: absolute;
          border-radius: 50%;
          background: #fff3c4;
          box-shadow: 0 0 6px 1px rgba(255, 243, 196, 0.8);
          animation: pms-star 3.2s ease-in-out infinite;
        }
        @keyframes pms-star { 0%, 100% { opacity: 0.2; transform: scale(0.8); } 50% { opacity: 1; transform: scale(1.4); } }

        .pms-hindi {
          margin: 14px 0 0;
          font-family: "Yatra One", "Noto Sans Devanagari", serif;
          font-size: 44px;
          line-height: 1.15;
          font-weight: 400;
          background: linear-gradient(180deg, #fff3c4 10%, var(--gold) 55%, var(--saffron));
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          filter: drop-shadow(0 0 14px rgba(255, 170, 40, 0.45));
        }

        .pms-countdown {
          align-self: flex-start;
          display: inline-block;
          margin-top: 12px;
          padding: 6px 14px;
          font-size: 13px;
          font-weight: 600;
          color: var(--gold);
          border: 1px solid rgba(255, 201, 60, 0.55);
          border-radius: 999px;
          background: rgba(255, 140, 26, 0.14);
          box-shadow: 0 0 16px rgba(255, 140, 26, 0.25);
        }

        /* Diya lit / unlit */
        .pms-diya-off .pms-flame-outer,
        .pms-diya-off .pms-flame-inner { opacity: 0; transform: scale(0.2); animation: none; filter: none; }
        .pms-diya .pms-flame-outer, .pms-diya .pms-flame-inner { transition: opacity 0.4s, transform 0.4s; }
        .pms-diya-off .pms-diya-bowl { fill: #b8691a; }
        .pms-diya-row .pms-diya:not(.pms-diya-off) { filter: drop-shadow(0 0 10px rgba(255, 170, 40, 0.7)); }

        /* Click sparkles */
        .pms-spark { position: fixed; width: 0; height: 0; pointer-events: none; z-index: 9999; }
        .pms-spark i {
          position: absolute;
          left: -2px; top: -2px;
          width: 5px; height: 5px;
          border-radius: 50%;
          background: var(--gold);
          box-shadow: 0 0 8px 2px rgba(255, 170, 40, 0.9);
          animation: pms-spark 0.75s ease-out forwards;
        }
        @keyframes pms-spark {
          from { transform: rotate(var(--a)) translateX(0); opacity: 1; }
          to { transform: rotate(var(--a)) translateX(34px) scale(0.2); opacity: 0; }
        }

        /* Success confetti */
        .pms-confetti { position: fixed; inset: 0; pointer-events: none; overflow: hidden; z-index: 9998; }
        .pms-confetti i {
          position: absolute;
          top: -16px;
          width: 9px; height: 14px;
          border-radius: 2px;
          animation-name: pms-fall;
          animation-timing-function: ease-in;
          animation-fill-mode: forwards;
        }
        @keyframes pms-fall {
          from { transform: translateY(0) rotate(var(--r)); opacity: 1; }
          to { transform: translateY(105vh) rotate(calc(var(--r) + 540deg)); opacity: 0.9; }
        }

        /* Card glow ring */
        .pms-form-card::after {
          content: "";
          position: absolute;
          inset: -1px;
          border-radius: 9px;
          pointer-events: none;
          box-shadow: 0 0 0 1px rgba(255, 201, 60, 0.5), 0 0 32px rgba(255, 140, 26, 0.18);
          animation: pms-glow 3.5s ease-in-out infinite;
        }
        @keyframes pms-glow { 0%, 100% { opacity: 0.55; } 50% { opacity: 1; } }

        @media (max-width: 1024px) { .pms-hindi { font-size: 36px; } }
        @media (max-width: 640px) { .pms-hindi { font-size: 30px; margin-top: 10px; } .pms-countdown { font-size: 12px; } }
        @media (prefers-reduced-motion: reduce) {
          .pms-stars i, .pms-form-card::after { animation: none; }
          .pms-spark, .pms-confetti { display: none; }
        }

        /* ---------- Responsive ---------- */
        @media (max-width: 1024px) {
          .pms-login { flex-direction: column; }
          .pms-left { padding: 70px 24px 40px; }
          .pms-left::after { top: auto; left: 0; width: auto; height: 10px; }
          .pms-lights { right: 0; }
          .pms-brand-row h1 { font-size: 48px; }
        }

        @media (max-width: 640px) {
          .pms-schedule, .pms-feature-list { display: none; }
          .pms-left { padding: 64px 20px 32px; }
          .pms-right { padding: 24px 16px; }
          .pms-form-card { padding: 28px 22px; }
          .pms-brand-full { font-size: 19px; }
          .pms-diya-brand { width: 44px; }
          .pms-bulb:nth-child(even) { display: none; }
        }

        @media (prefers-reduced-motion: reduce) {
          .pms-task { animation: none; transform: scaleX(1); }
          .pms-input-container, .pms-login-button { transition: none; }
        }
      `}</style>
    </>
  );
};

export default Login;
